import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPerformanceObject, getWindowObject } from '../../../utils/window-helper';
import { getResourceTimings } from '../../resource-timings-buffer';
var cacheableTypes = ['script', 'link'];
var resourceTypes = ['fetch', 'xmlhttprequest'];
var CACHE_NETWORK = 'network';
var CACHE_MEMORY = 'memory';
var CACHE_DISK = 'disk';
var calculateTransferType = function calculateTransferType(type, duration, size) {
  if (!cacheableTypes.includes(type)) {
    return CACHE_NETWORK;
  }
  if ((size === undefined || size === 0) && duration === 0) {
    return CACHE_MEMORY;
  }
  if (size === 0 && duration > 0) {
    return CACHE_DISK;
  }
  if (size === undefined) {
    return null;
  }
  return CACHE_NETWORK;
};
var hasAccessToResourceSize = function hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
  return !cacheableTypes.includes(type) || url.includes('localhost') || !!getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
var getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
  if (xhrEnabled) {
    return ['script', 'link', 'fetch', 'xmlhttprequest'];
  }
  return ['script', 'link', 'fetch'];
};
var evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(_url, entry) {
  return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
var getSizeObject = function getSizeObject(size) {
  return size !== undefined ? {
    size: size
  } : null;
};
var getNetworkData = function getNetworkData(item, eventStart) {
  var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : evaluateAccessToResourceTimings;
  var name = item.name,
    duration = item.duration,
    transferSize = item.transferSize,
    initiatorType = item.initiatorType,
    responseStart = item.responseStart;
  var ttfb = Math.round(responseStart - eventStart);
  if (!hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) {
    return {};
  }
  if (cacheableTypes.includes(initiatorType)) {
    var transferType = calculateTransferType(initiatorType, duration, transferSize);
    if (!transferType) {
      return _objectSpread({
        ttfb: ttfb
      }, getSizeObject(transferSize));
    }
    if (transferType !== CACHE_NETWORK) {
      return {
        transferType: transferType
      };
    }
    return _objectSpread({
      ttfb: ttfb,
      transferType: transferType
    }, getSizeObject(transferSize));
  }
  return _objectSpread({
    ttfb: ttfb
  }, getSizeObject(transferSize));
};
export var resourceTimings = function resourceTimings(data, _resourceTimings) {
  var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getPerformanceObject() || undefined;
  if (data.result.startTime === null || !(_resourceTimings !== null && _resourceTimings !== void 0 && _resourceTimings.sanitiseEndpoints)) {
    return null;
  }
  var resources = getResourceTimings(data.result.startTime, performance);
  if (!(resources !== null && resources !== void 0 && resources.length)) {
    return null;
  }
  var resourceTiming = {};
  var xhrFilter = _resourceTimings.xhrFilter;
  var reportedInitiatorTypes = getReportedInitiatorTypes(!!xhrFilter);
  resources.forEach(function (item) {
    if (!reportedInitiatorTypes.includes(item.initiatorType)) {
      return;
    }
    var name = item.name,
      startTime = item.startTime,
      duration = item.duration,
      workerStart = item.workerStart,
      fetchStart = item.fetchStart,
      initiatorType = item.initiatorType;
    if (!name || data.result.startTime === null) {
      return;
    }
    if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) {
      return;
    }
    var url = resourceTypes.includes(initiatorType) ? _resourceTimings.sanitiseEndpoints(name) : _resourceTimings.mapResources(name);
    if (!url || resourceTiming[url]) {
      return;
    }
    resourceTiming[url] = _objectSpread({
      startTime: Math.round(startTime - data.result.startTime),
      duration: Math.round(duration),
      workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
      fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
      type: initiatorType
    }, getNetworkData(item, data.result.startTime, _resourceTimings.hasTimingHeaders));
  });
  return {
    'timings:resource': resourceTiming
  };
};